import ApiService from '@/services/api.service'
import _ from 'lodash'
import i18n from '@/plugins/i18n'
import { DateTime } from 'luxon'


export { DateTime } from 'luxon'

export function fetchList (component, variableName, url, filterAttribute, filterValue) {
    let params = _.set({}, 'filter[' + filterAttribute + ']', filterValue)
    ApiService.index(url, null, {
        params: params,
    }).then(values => {
        component[variableName] = values
    }).catch(error => {
        console.log(error)
        alert(`Could not fetch data for list ${variableName}`)
    })
}

/**
 * Same as fetchMultipleLists, but with keys and values of tagVariableMap swapped,
 * so that the same tag can be reused for multiple variables
 */
 export function fetchMultipleLists2 (component, variableTagMap, url, filterAttribute) {

    let tags = [];
    Object.keys( variableTagMap ).forEach(variable => {
        tags.push(variableTagMap[variable])
    })

    let params = _.set({}, 'filter[' + filterAttribute + ']', tags)
    ApiService.index(url, null, {
        params: params,
    }).then(lists => {
        Object.keys( variableTagMap ).forEach(variableName => {
            component[variableName] = lists[ variableTagMap[variableName] ]
        })
    }).catch(error => {
        console.log(error)
        alert(`Could not fetch data for list ${variableTagMap}`)
    })
}

export function fetchMultipleLists (component, tagVariableMap, url, filterAttribute) {

    let tags = [];
    Object.keys( tagVariableMap ).forEach(tag => {
        tags.push(tag)
    })

    let params = _.set({}, 'filter[' + filterAttribute + ']', tags)
    ApiService.index(url, null, {
        params: params,
    }).then(lists => {
        Object.keys( tagVariableMap ).forEach(tag => {
            let variableName = tagVariableMap[tag]
            component[variableName] = lists[tag]
        })
    }).catch(error => {
        console.log(error)
        alert(`Could not fetch data for list ${tagVariableMap}`)
    })
}

// Returns date in the current locale format
export function formatDate(datetime) {
    return datetime.setLocale(i18n.locale).toLocaleString(DateTime.DATE_MED)
}

// Returns date and time in the current locale format
export function formatDateTime(datetime) {
    return datetime.setLocale(i18n.locale).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)
}

/* Formats the date in the requested dd-MMM-yyyy format, where MMM is translated
export function formatDate(date) {
    const months = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec',
    }

    if (undefined === date || 'string' !== typeof date) {
        return ''
    }

    let array = date.split("-")
    if (!Array.isArray(array)) {
        return ''
    }

    let month = parseInt(array[1])
    if (month in months) {
        month = i18n.t(months[month])
    }

    let result = array[2] + '/' + month + '/' + array[0]

    return result
}
*/

